<template>
    <div class="configurator" :class="{'configurator--loading': isLoading}" v-if="activeProductData">
        <p class="configurator__cta">{{ $translate('Weberbuero::Template.configuratorCTA') }}:</p>
        <ul class="configurator-variants__list">
            <li v-for="product in productList" class="configurator-variants__item"
                :class="{'configurator-variants__item--active': activeProductData.id === product.id }"
                @click="switchArticle(product.varId)">
                <div class="configurator-variants__img-wrap">
                    <div class="configurator-variants__img-container">
                        <lazy-img class="configurator-variants__img"
                                  :is-background-image="true"
                                  :image-url="'https://bilder.weberbuero.de/frontend/images/materials/thumbs/'  + product.img + '.jpg'"/>
                    </div>
                </div>
                <div class="configurator-variants__title">
                    <p>{{product.name}}</p>
                </div>
            </li>
        </ul>
        <div class="configurator__container">
            <p class="configurator__cta">{{ $translate('Weberbuero::Template.configuratorCTA2') }}:
                <template v-for="(color, key) in activeColorList"
                          v-if="(parseInt(color.attributeValueId) === activeColor.value)  && varSwitched">{{color.name}}
                </template>
            </p>

            <div class="configurator__loading" v-if="isLoading"></div>
            <div class="swiper-container conf-swiper" ref="swiper">
                <div class="configurator__item-wrapper"
                     v-if="activeAttributes && activeAttributes[swiperColor] && activeColorList.length > 5">
                    <div v-for="(color, key) in activeColorList"
                         v-if="key < 4 || parseInt(color.attributeValueId) === activeColor.value"
                         class="configurator__item"
                         v-show="!(key > 4 && parseInt(color.attributeValueId) === activeColor.value)">
                        <div @click="selectAttribute(swiperColor, color.attributeValueId); clickCount++">
                            <lazy-img class="configurator__color-card"
                                      :class="{'configurator__color-card--active': (parseInt(color.attributeValueId) === activeColor.value) && varSwitched, 'sold': !isAttributeSelectionValid(color.attributeId, color.attributeValueId, true) }"
                                      :is-background-image="true"
                                      :image-url="'https://bilder.weberbuero.de/frontend/images/materials/thumbs/'  +  color.name.split(' ')[0] + '.jpg'">
                                <div class="configurator__label">
                                    <p>{{color.name}}</p>
                                </div>
                            </lazy-img>
                        </div>
                    </div>

                    <portal to="sidebar" v-if="sidebarContent === activeAttributes[swiperColor].attributeId">
                        <span class="single__variations-select-label">{{ $translate('Weberbuero::Template.configuratorCTA2') }}:</span>

                        <div class="configurator__item-wrapper">
                            <div v-for="(color, key) in activeColorList" class="configurator__item"
                                 :class="{'active': parseInt(color.attributeValueId) === activeColor.value}">
                                <div @click="selectAttribute(swiperColor, color.attributeValueId); toggleSidebar();">
                                    <lazy-img class="configurator__color-card"
                                              :class="{'configurator__color-card--active': (color.attributeValueId === activeColor.value) && currentVariation.attributes.length > 0, 'sold': !isAttributeSelectionValid(color.attributeId, color.attributeValueId, true) }"
                                              :is-background-image="true"
                                              :image-url="'https://bilder.weberbuero.de/frontend/images/materials/thumbs/'  +  color.name.split(' ')[0] + '.jpg'">
                                        <div class="configurator__label">
                                            <p>{{color.name}}</p>
                                        </div>
                                    </lazy-img>
                                </div>
                            </div>
                        </div>
                    </portal>

                    <div class="configurator__item">
                        <div class="sidebar-toggle" @click="toggleSidebar(activeAttributes[swiperColor].attributeId);">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                                 fill="none">
                                <g style="mix-blend-mode:multiply">
                                    <circle cx="17" cy="17" r="17" fill="#3F3F3F"/>
                                </g>
                                <path d="M17 17V23M11 17H17H11ZM23 17H17H23ZM17 17V11V17Z" stroke="white"
                                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <div>Alle ansehen</div>
                        </div>


                    </div>
                </div>
                <div class="configurator__item-wrapper"
                     v-if="activeAttributes && activeAttributes[swiperColor] && activeColorList.length <= 5">
                    <div v-for="(color, key) in activeColorList" v-if="key < 4" class="configurator__item">
                        <div @click="selectAttribute(swiperColor, color.attributeValueId)">
                            <lazy-img class="configurator__color-card"
                                      :class="{'configurator__color-card--active': (color.attributeValueId === activeColor.value) && varSwitched, 'sold': !isAttributeSelectionValid(activeColor.value, color.attributeValueId, true) }"
                                      :is-background-image="true"
                                      :image-url="'https://bilder.weberbuero.de/frontend/images/materials/thumbs/'  +  color.name.split(' ')[0] + '.jpg'">
                                <div class="configurator__label">
                                    <p>{{color.name}}</p>
                                </div>
                            </lazy-img>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="configurator__muster">
            <a href="#" class="js--single__muster-link single__muster-link" @click="detachModal()" data-toggle="modal"
               data-target="#confi-muster">
                <svg class="svg_gift" width="16" height="20">
                    <use xlink:href="#svg_cards" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                {{ activeProductData.name }} {{ $translate("Weberbuero::Template.orderMuster") }}&nbsp;&nbsp;
            </a>
        </div>

        <div class="configurator__row configurator__select-list" v-if="activeAttributes">
            <div class="configurator__col" v-for="(attribute, key) in attributeSelectList">
                <template v-if="attribute.type === 'image'">
                    <div class="configurator__select-img" v-if="attribute.values.length > 4">

                        <span class="single__variations-select-label">{{ attribute.name }}:</span>

                        <template v-if="selectedAttributes[attribute.attributeId] !== null">
                            <div @click="toggleSidebar(attribute.attributeId)"
                                 class="configurator__select-list-outer-button configurator__select-list-outer-button--img"
                                 v-for="(value, key2) in attribute.values"
                                 v-if="value.attributeValueId == selectedAttributes[attribute.attributeId]">
                        <span class="configurator__select-list-outer-button-content">
                          <div class="configurator__select-list-outer-button-img-wrapper">
                            <lazy-img class="p-1" :image-url="value.imageUrl" :alt="value.name"/>
                          </div>
                          <span>
                            {{value.name}}
                          </span>
                        </span>

                                <svg height="7" width="11" class="single__select--right">
                                    <use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </div>
                        </template>

                        <portal to="sidebar" v-if="sidebarContent === attribute.attributeId">
                            <span class="single__variations-select-label">{{ attribute.name }}:</span>

                            <ul class="configurator__select-list configurator__select-list--img">
                                <li class="configurator__select-list-item"
                                    :class="{ 'active': value.attributeValueId == selectedAttributes[attribute.attributeId], 'sold': !isAttributeSelectionValid(attribute.attributeId, value.attributeValueId, true)}"
                                    v-for="(value, key2) in attribute.values"
                                    @click="selectAttribute(attribute.attributeId, value.attributeValueId); toggleSidebar();">
                                    <div class="configurator__select-list-item-img-wrapper">
                                        <lazy-img class="p-1" :image-url="value.imageUrl" :alt="value.name"/>
                                    </div>
                                    <span>
                            {{value.name}}
                          </span>
                                </li>
                            </ul>
                        </portal>
                    </div>

                    <template v-else>
                        <div class="configurator__select-img">
                            <span class="single__variations-select-label">{{ attribute.name }}: <span
                                v-for="value in attribute.values"
                                v-if="value.attributeValueId == selectedAttributes[attribute.attributeId]">{{ value.name }}</span></span>
                            <div class="configurator__select-img-item-wrapper">
                                <div class="configurator__select-img-item"
                                     v-for="value in attribute.values"
                                     @click="selectAttribute(attribute.attributeId, value.attributeValueId)"
                                     :class="{ 'active': value.attributeValueId == selectedAttributes[attribute.attributeId], 'sold': !isAttributeSelectionValid(attribute.attributeId, value.attributeValueId, true)}"
                                     data-toggle="tooltip" data-placement="top" :title="value.name">
                                    <lazy-img class="p-1" :image-url="value.imageUrl" :alt="value.name"/>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="configurator__select"> <!--v-else-->
                        <label class="single__variations-select-label">{{ attribute.name }}</label>

                        <template v-if="attribute.values.length > 3">
                            <template v-if="selectedAttributes[attribute.attributeId] !== null">
                                <div @click="toggleSidebar(attribute.attributeId)"
                                     class="configurator__select-list-outer-button"
                                     v-for="(value, key2) in attribute.values"
                                     v-if="value.attributeValueId == selectedAttributes[attribute.attributeId]">
                                    <span>{{ value.name }}</span>

                                    <svg height="7" width="11" class="single__select--right">
                                        <use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </div>
                            </template>

                            <div v-else>{{attribute.values[0].name}}</div>
                        </template>

                        <template v-if="attribute.values.length > 3">
                            <portal to="sidebar" v-if="sidebarContent === attribute.attributeId">
                                <span class="single__variations-select-label">{{ attribute.name }}:</span>

                                <ul class="configurator__select-list">
                                    <li class="configurator__select-list-item"
                                        :class="{ 'active': value.attributeValueId == selectedAttributes[attribute.attributeId], 'sold': !isAttributeSelectionValid(attribute.attributeId, value.attributeValueId, true) }"
                                        v-for="(value, key2) in attribute.values"
                                        @click="selectAttribute(attribute.attributeId, value.attributeValueId); toggleSidebar();">
                                        {{value.name}}
                                    </li>
                                </ul>
                            </portal>
                        </template>

                        <div class="configurator__select-buttons-wrapper" v-else>
                            <div class="configurator__select-button" v-for="(value, key2) in attribute.values"
                                 @click="selectAttribute(attribute.attributeId, value.attributeValueId)"
                                 :class="{ 'active': value.attributeValueId == selectedAttributes[attribute.attributeId], 'sold': !isAttributeSelectionValid(attribute.attributeId, value.attributeValueId, true) }">
                                {{value.name}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <DetailsModal
            v-if="this.colorArray.length > 0 && modalSelectedColor.id"
            :activeAttributes="activeAttributes"
            :colorArray="colorArray"
            :swiperColor="swiperColor"
            :modalSelectedColor="modalSelectedColor"
            @selectModalColor="selectModalColor"
        />
        <MusterModal
            :modalActiveArticle="modalActiveArticle"
            :productList="productList"
            :modalSelectedMuster="modalSelectedMuster"
            @switchMuster="switchMuster"
        />

        <input v-for="(item, index) in confiArticleList" type="hidden" :value="item.id"
               :class="'confiArticleListItemId'+index">
    </div>
</template>

<script>
import DetailsModal from './DetailsModal.vue';
import ApiService from 'ceres/app/services/ApiService';
import TranslationService from 'ceres/app/services/TranslationService';
import MusterModal from './MusterModal.vue';
import {get} from 'ceres/app/helper/get';
import {navigateTo} from 'ceres/app/services/UrlService';
import {isDefined, isNull, isNullOrUndefined} from 'ceres/app/helper/utils';

const NotificationService = require('ceres/app/services/NotificationService');

export default {

    name: 'WallConfigurator',

    components:
        {
            MusterModal,
            DetailsModal,
        },
    props:
        {
            confiArticleList: Array,
            swiperColorList: Array,
            confiArticleMatrix: {
            },
            itemData: {
                type: Object,
                default: null,
            },
            isQuickView: {
                type: Boolean,
                default: false,
            },
        },
    data() {
        return {
            filteredVariationsCache: {},
            productList: [],
            activeProductData: null,
            isLoading: false,
            swiperConf: null,
            filteredVariations: [],
            MusterModalOpen: false,
            modalSelectedMuster: null,
            varSwitched: false,
            lastContentCount: 0,
            modalSelectedColor: {
                id: null,
                img: null,
                name: null,
            },
            usedItemId: this.itemData !== null ? this.itemData.item.id : this.itemId,
            firstSwiperInit: true,
            sidebarContent: 0,
            clickCount: 0
        };
    },

    inject: {
        itemId: {
            default: null,
        },
    },

    computed:
        {
            attributes() {
                return get(this.$store.state, `items[${this.usedItemId}].variationSelect.attributes`);
            },

            activeAttributes() {
                return this.activeProductData.attributes || null;
            },

            /**
             * returns the variation, based on the selected attributes / unit
             * returns false if there are none or multiple results
             */
            currentSelection() {
                const filteredVariations = this.filterVariations(null, null, true);

                if (filteredVariations.length === 1) {
                    return filteredVariations[0];
                }

                return false;
            },

            /**
             * returns all units, selectable by current selection
             * prop 'forceContent' with value true will return all units, without filtering
             */
            possibleUnits() {
                // use an object, to make the entries unique
                const possibleUnits = {};
                const variations = this.forceContent ? this.variations : this.filterVariations(null, null, null, true);

                for (const variation of variations) {
                    possibleUnits[variation.unitCombinationId] = variation.unitName;
                }

                return possibleUnits;
            },

            isContentVisible() {
                return !this.forceContent && !!this.currentSelection || this.forceContent;
            },

            activeColor() {
                let usedVar = null;
                if (typeof this.activeAttributes[this.swiperColor] === 'undefined') {
                    usedVar = this.activeAttributes[Object.keys(this.activeAttributes)[0]];
                } else {
                    usedVar = this.activeAttributes[this.swiperColor];
                }

                if (usedVar.values === null || typeof usedVar.values === 'undefined') {
                    let attrWithValues = {};
                    for (let key in this.attributes) {
                        attrWithValues[this.attributes[key].attributeId] = this.attributes[key];
                    }

                    usedVar = attrWithValues[this.swiperColor];
                }

                if (!(this.swiperColor && this.activeAttributes)) return {color: null, value: null};
                return {
                    color: this.activeAttributes
                        ? usedVar.values[this.selectedAttributes[this.swiperColor]] || ' '
                        : ' ',
                    value: this.selectedAttributes[this.swiperColor] || null,
                };
            },

            attributeIds() {
                return this.initialAttributes.map(attr => attr.attributeId);
            },

            swiperColor() {
                if (!(this.swiperColorList && this.attributeIds)) {
                    return null;
                }

                return Object.keys(this.activeAttributes)[0];
            },

            activeColorList() {
                let usedVar = null;
                let usedVar1 = null;
                if (typeof this.activeAttributes[parseInt(this.swiperColor)] === 'undefined') {
                    usedVar = this.activeAttributes[Object.keys(this.activeAttributes)[0]];
                    usedVar1 = this.activeAttributes[Object.keys(this.activeAttributes)[0]];
                } else {
                    usedVar = this.activeAttributes[parseInt(this.swiperColor)];
                    usedVar1 = this.activeAttributes[parseInt(this.swiperColor)];
                }

                if (usedVar.values === null || typeof usedVar.values === 'undefined') {
                    let attrWithValues = {};
                    for (let key in this.attributes) {
                        attrWithValues[this.attributes[key].attributeId] = this.attributes[key];
                    }

                    usedVar = attrWithValues[parseInt(this.swiperColor)];
                }

                let newReturnArray = [];

                for (let key in usedVar.values) {
                    if (usedVar.values.hasOwnProperty(key)) {
                        if (typeof usedVar.values[key].name === 'undefined') {
                            newReturnArray.push({
                                'attributeId': usedVar.attributeId,
                                'attributeValueId': key,
                                'name': usedVar.values[key],
                            });
                        } else {
                            newReturnArray[key] = usedVar.values[key];
                        }
                    }
                }

                return newReturnArray;
            },

            attributeSelectList() {
                let selectAttributes = {};

                for (let key in this.attributes) {
                    if (this.attributes[key].attributeId != this.swiperColor) {
                        selectAttributes[this.attributes[key].attributeId] = this.attributes[key];
                    }
                }

                return selectAttributes;
            },

            modalActiveArticle() {
                if (!this.modalSelectedMuster) {
                    return '';
                }
                const activeArticle = this.productList.find(x => x.id === this.modalSelectedMuster);

                return (activeArticle.name + ' (' + activeArticle.id + ')');
            },

            colorArray() {
                let usedVar = null;
                if (typeof this.activeAttributes[this.swiperColor] === 'undefined') {
                    usedVar = this.activeAttributes[Object.keys(this.activeAttributes)[0]];
                } else {
                    usedVar = this.activeAttributes[this.swiperColor];
                }

                if (usedVar.values === null || typeof usedVar.values === 'undefined') {
                    let attrWithValues = {};
                    for (let key in this.attributes) {
                        attrWithValues[this.attributes[key].attributeId] = this.attributes[key];
                    }

                    usedVar = attrWithValues[this.swiperColor];
                }

                return this.activeAttributes && typeof usedVar !== 'undefined' ? Object.keys(usedVar.values) : [];
            },

            currentVariation() {
                return this.$store.getters[`${this.usedItemId}/currentItemVariation`];
            },

            currentVariationSelect() {
                return this.$store.state.items[this.usedItemId] &&
                    this.$store.state.items[this.usedItemId].variationSelect;
            },

            initialAttributes() {
                return this.currentVariationSelect && this.currentVariationSelect.attributes;
            },

            variations() {
                return this.currentVariationSelect && this.currentVariationSelect.variations;
            },

            initalActiveProduct() {
                return this.usedItemId;
            },

            possibleUnitCombinationIds() {
                return this.transformPossibleUnits(this.possibleUnits).map(value => value[0]);
            },

            hasSelection() {
                return !isNullOrUndefined(this.selectedAttributes) &&
                    !Object.values(this.selectedAttributes).some((value) => value < 0);
            },

            selectedAttributes() {
                return this.currentVariationSelect && this.currentVariationSelect.selectedAttributes;
            },

            selectedUnit() {
                return this.currentVariationSelect && this.currentVariationSelect.selectedUnit;
            },
        },

    watch:
        {
          currentVariation:
              {
                handler(val, oldVal)
                {
                  if (val !== oldVal)
                  {
                    setTimeout(() =>
                    {
                      this.varSwitched = true;
                    }, 1);
                  }
                },
              },

            'activeProductData.id': function(newId, oldId) {
                // update swiper when article (not variation) ID changes
                if (newId && oldId !== newId) {
                    if (this.swiperConf) {
                        if (!this.firstSwiperInit) {
                            this.swiperConf.destroy();
                        }

                        this.firstSwiperInit = false;

                        // initialize Attribute List again to reset previous selections
                        this.resetAttributeList();
                        this.$nextTick(() => {
                            // this.initSwiper();
                        });
                    }
                    // reset modal color and Muster when article changes
                    this.selectModalColor(this.colorArray[0]);
                    this.switchMuster(newId);

                    this.$nextTick(() => {
                        document.querySelectorAll('[data-toggle="tooltip"]').forEach(el => {
                            $(el).tooltip();
                        });
                    });
                }
            },

            variations() {
                // FIX unset variation cache after subsequent variations are loaded
                this.filteredVariationsCache = {};
            },
        },

    mounted() {
        this.fillProductList();

        this.$nextTick(() => {
            // this.initSwiper();
            document.querySelectorAll('[data-toggle="tooltip"]').forEach(el => {
                $(el).tooltip();
            });
        });


        /*let _this = this
        setTimeout(function(){
          console.log("test")

          let attr = _this.selectedAttributes

          console.log(attr)


          let flag = false
          for(let key in _this.selectedAttributes){
            if(flag === false){
              console.log(key)
              console.log(attr[key])

              _this.selectAttribute(key, attr[key])

              flag = true;
            }
          }
        },1)*/


    },

    methods:
        {
            /**
             * select an attribute and check, if the selection is valid; if not, unsetInvalidSelection will be executed
             * @param {number} attributeId
             * @param {[number, string, null]} attributeValueId
             */
            selectAttribute(attributeId, attributeValueId) {
                attributeValueId = parseInt(attributeValueId) || null;

                if (this.selectedAttributes[attributeId] !== attributeValueId || this.clickCount <= 1) {
                    this.$store.commit(`${this.itemId}/variationSelect/selectItemAttribute`,
                        {attributeId, attributeValueId});
                    this.onSelectionChange(attributeId, attributeValueId, null);
                }
            },

            /**
             * select a unit and check, if the selection is valid; if not, unsetInvalidSelection will be executed
             * @param {[number, string]} unitId
             */
            selectUnit(unitId) {
                unitId = parseInt(unitId);
                this.$store.commit(`${this.itemId}/variationSelect/selectItemUnit`, unitId);
                this.onSelectionChange(null, null, unitId);
            },

            onSelectionChange(attributeId, attributeValueId, unitId) {
                if (this.currentSelection) {
                    this.setVariation(this.currentSelection.variationId);
                } else if (!this.hasSelection) {
                    // user switched back to "please select"
                    this.setVariation(0);
                } else {
                    this.unsetInvalidSelection(attributeId, attributeValueId, unitId);
                }

                this.lastContentCount = this.possibleUnitCombinationIds.length;
            },

            /**
             * changes the selected attributes / unit, to ensure a valid seelction
             * @param {[number, null]} attributeId
             * @param {[number, null]} attributeValueId
             * @param {[number, null]} unitId
             */
            unsetInvalidSelection(attributeId, attributeValueId, unitId) {
                const qualifiedVariations = this.getQualifiedVariations(attributeId, attributeValueId, unitId);
                const closestVariations = this.getClosestVariations(qualifiedVariations);

                // if the salable 'closestVariations' is undefined, take the not-salable one
                const closestVariation = closestVariations[0] || closestVariations[1];

                if (!closestVariation) {
                    this.unsetInvalidSelection(null, null, null);
                    this.selectAttribute(attributeId, attributeValueId);
                    return;
                }

                const invalidSelection = this.getInvalidSelectionByVariation(closestVariation);
                this.correctSelection(invalidSelection);
            },

            /**
             * returns a list of variations, filtered by attribute or unit
             * @param {[number, null]} attributeId
             * @param {[number, null]} attributeValueId
             * @param {[number, null]} unitId
             */
            getQualifiedVariations(attributeId, attributeValueId, unitId) {
                if (isDefined(attributeValueId)) {
                    return this.variations.filter(variation => {
                        return isDefined(variation.attributes.find(attribute =>
                            attribute.attributeId === attributeId && attribute.attributeValueId === attributeValueId));
                    });
                } else if (isDefined(unitId)) {
                    return this.variations.filter(variation => variation.unitCombinationId === unitId);
                }

                return this.variations.filter(variation => !variation.attributes.length);
            },

            /**
             * return a salable and a non-salable variation with the minimum number of changes on attributes compared to the current selection.
             * @param {array} qualifiedVariations
             */
            getClosestVariations(qualifiedVariations) {
                let closestSalableVariation, numberOfSalableChanges;
                let closestNonSalableVariation, numberOfNonSalableChanges;

                for (const variation of qualifiedVariations) {
                    let changes = 0;

                    if (variation.unitCombinationId !== this.selectedUnit && !isNull(this.selectedUnit)) {
                        // when the unit dropdown isn't visible, it should have a lower weight for reset investigations
                        const unitWeight = this.possibleUnitCombinationIds.length > 1 && this.isContentVisible
                            ? 0.9
                            : 0.1;

                        changes += unitWeight;
                    }

                    for (const attribute of variation.attributes) {
                        if (this.selectedAttributes[attribute.attributeId] !== attribute.attributeValueId) {
                            changes++;
                        }
                    }

                    if (variation.isSalable && (!numberOfSalableChanges || changes < numberOfSalableChanges)) {
                        closestSalableVariation = variation;
                        numberOfSalableChanges = changes;
                    } else if (!variation.isSalable &&
                        (!numberOfNonSalableChanges || changes < numberOfNonSalableChanges)) {
                        closestNonSalableVariation = variation;
                        numberOfNonSalableChanges = changes;
                    }
                }

                return [closestSalableVariation, closestNonSalableVariation];
            },

            /**
             * returns object with array 'attributesToReset' and newUnit. The attributesToReset contains all attributes, which are not matching with the given variation
             * @param {object} variation
             */
            getInvalidSelectionByVariation(variation) {
                const attributesToReset = [];
                let newUnit = null;

                for (let selectedAttributeId in this.selectedAttributes) {
                    selectedAttributeId = parseInt(selectedAttributeId);
                    const variationAttribute = variation.attributes.find(
                        attribute => attribute.attributeId === selectedAttributeId);

                    if (!isNull(this.selectedAttributes[selectedAttributeId])) {
                        if (variationAttribute && variationAttribute.attributeValueId !==
                            this.selectedAttributes[selectedAttributeId] || !variationAttribute) {
                            const attributeToReset = this.attributes.find(
                                attr => attr.attributeId === selectedAttributeId);

                            attributesToReset.push(attributeToReset);
                        }
                    }
                }

                if (variation.unitCombinationId !== this.selectedUnit) {
                    newUnit = variation.unitCombinationId;
                }

                return {attributesToReset, newUnit};
            },

            /**
             * resets all invalid attributes and change the unit, if required. Prints a message to the user if so.
             * @param {object} invalidSelection
             */
            correctSelection(invalidSelection) {
                const messages = [];
                const attributes = JSON.parse(JSON.stringify(this.selectedAttributes));

                for (const attributeToReset of invalidSelection.attributesToReset) {
                    messages.push(
                        this.$translate('Ceres::Template.singleItemNotAvailable', {name: attributeToReset.name}),
                    );

                    attributes[attributeToReset.attributeId] = (!this.hasEmptyOption &&
                        App.config.item.showPleaseSelect) ? -1 : null;
                }

                if (invalidSelection.newUnit) {
                    if (this.lastContentCount > 1 && this.possibleUnitCombinationIds.length > 1 &&
                        !isNull(this.selectedUnit)) {
                        messages.push(
                            this.$translate('Ceres::Template.singleItemNotAvailable', {
                                name:
                                    this.$translate('Ceres::Template.singleItemContent'),
                            }),
                        );
                    }

                    this.$store.commit(`${this.itemId}/variationSelect/selectItemUnit`, invalidSelection.newUnit);
                }

                this.$store.commit(`${this.itemId}/variationSelect/setItemSelectedAttributes`, attributes);

                this.setVariation(this.currentSelection ? this.currentSelection.variationId : 0);

                NotificationService.warn(
                    messages.join('<br>'),
                ).closeAfter(5000);
            },
            filterVariations(attributes, unitId, strict, ignoreUnit) {
                attributes = attributes || this.selectedAttributes;
                unitId = unitId || this.selectedUnit;
                strict = !!strict;
                ignoreUnit = !!ignoreUnit;

                const key = JSON.stringify(attributes) + '_' + unitId + '_' + strict + '_' + ignoreUnit;

                if (isDefined(this.filteredVariationsCache[key])) {
                    return this.filteredVariationsCache[key];
                }

                const uniqueValues = [...new Set(Object.values(attributes))];
                const isEmptyOptionSelected = uniqueValues.length === 1 && isNull(uniqueValues[0]);
                const filteredVariations = this.variations.filter(variation => {
                    // the selected unit is not matching
                    if (!ignoreUnit && variation.unitCombinationId !== unitId) {
                        return false;
                    }

                    // the variation has no attributes (only checked, if any attribute has a selected value); or the variation has attributes and empty option is selected
                    // requires more than 0 attributes
                    if (((!isEmptyOptionSelected && !variation.attributes.length) ||
                            (isEmptyOptionSelected && variation.attributes.length))
                        && this.attributes.length > 0) {
                        return false;
                    }

                    for (const attributeId in attributes) {
                        const variationAttribute = variation.attributes.find(variationAttribute =>
                            variationAttribute.attributeId === parseInt(attributeId));

                        // an attribute is not matching with selection
                        if (variationAttribute &&
                            variationAttribute.attributeValueId !== attributes[attributeId] &&
                            (strict || !strict && !isNull(attributes[attributeId]) && attributes[attributeId] !== -1)) {
                            return false;
                        }
                    }

                    return true;
                });

                this.filteredVariationsCache[key] = filteredVariations;

                return filteredVariations;
            },

            /**
             * returns true, if the selection with a new attribute value would be valid
             * @param {number} attributeId
             * @param {[number, string, null]} attributeValueId
             * @param {boolean} filterSalableVariations
             */
            isAttributeSelectionValid(attributeId, attributeValueId, filterSalableVariations) {
                attributeValueId = parseInt(attributeValueId) || null;
                if (this.selectedAttributes[attributeId] === attributeValueId) {
                    return true;
                }

                const selectedAttributes = JSON.parse(JSON.stringify(this.selectedAttributes));

                selectedAttributes[attributeId] = parseInt(attributeValueId) || null;

                const ignoreUnit = !(Object.keys(this.possibleUnits).length > 1 && this.isContentVisible);
                let variations = this.filterVariations(selectedAttributes, null, null, ignoreUnit);

                if (filterSalableVariations) {
                    variations = variations.filter(variation => variation.isSalable);
                }
                return variations.length > 0;
            },

            /**
             * dispatch vuex action 'loadVariation' to archive a variation
             * dispatches a custom event named 'onVariationChanged'
             * @param {[string, number, null]} variationId
             */
            setVariation(variationId) {
                if (!isDefined(variationId) && this.currentSelection) {
                    variationId = this.currentSelection.variationId;
                }

                if (isDefined(variationId)) {
                    this.$store.dispatch(`${this.itemId}/loadVariation`, variationId).then(variation => {
                        document.dispatchEvent(new CustomEvent('onVariationChanged',
                            {
                                detail:
                                    {
                                        attributes: variation.attributes,
                                        documents: variation.documents,
                                        itemId: this.itemId,
                                    },
                            }));
                    });
                }
            },

            getSelectedAttributeValueName(attribute) {
                const selectedAttributeValueId = this.selectedAttributes[attribute.attributeId];
                const selectedAttributeValue = attribute.values.find(
                    attrValue => attrValue.attributeValueId === selectedAttributeValueId);

                return selectedAttributeValue ? selectedAttributeValue.name : TranslationService.translate(
                    'Ceres::Template.singleItemPleaseSelect');
            },

            transformPossibleUnits(possibleUnits) {
                return Object.entries(possibleUnits).sort((unitA, unitB) => {
                    unitA = this.splitUnitName(unitA[1]);
                    unitB = this.splitUnitName(unitB[1]);
                    // order by unit
                    if (unitA[1] < unitB[1]) {
                        return -1;
                    }
                    if (unitA[1] > unitB[1]) {
                        return 1;
                    }
                    // order by content (count)
                    if (unitA[0] < unitB[0]) {
                        return -1;
                    }
                    if (unitA[0] > unitB[0]) {
                        return 1;
                    }
                    return 0;
                });
            },

            splitUnitName(unitName) {
                const unitNameSplit = unitName.split(' ');

                if (!isNaN(unitNameSplit[0])) {
                    unitNameSplit[0] = unitNameSplit[0].replace(App.currencyPattern.separator_thousands, '');
                    unitNameSplit[0] = parseInt(unitNameSplit[0]);
                }

                return unitNameSplit;
            },

            toggleSidebar(attr) {
                document.body.classList.toggle('variation-sidebar--open');

                this.sidebarContent = attr;
            },

            detachModal() {
                $('#confi-muster-modal-wrapper').detach().appendTo('body');
                $('#confi-muster').css('zIndex', '1082');
            },

            switchArticle(varId, isVariation) {
                let linkArticle = this.confiArticleList.find(article => article.data.variation.id === varId);

                if (!isNullOrUndefined(linkArticle)) {
                    if (!this.isQuickView && linkArticle.data.variation.id !== this.activeProductData.varId) {
                        // sometimes texts is array, but the filter needs an object
                        if (Array.isArray(linkArticle.data.texts)) {
                            linkArticle.data.texts = linkArticle.data.texts[0];
                        }

                        navigateTo(this.$options.filters.itemURL(linkArticle.data));

                        return;

                    } else if (linkArticle.data.variation.id === this.activeProductData.varId) {
                        return;
                    }
                }

                this.isLoading = true;
                isVariation = isVariation || false;

                let targetArticle = this.productList.find(article => article.varId === varId);

                let promiseList = [
                    this.$store.dispatch(`${this.usedItemId}/loadVariation`, varId).then(res => {
                        if (!isVariation) {
                            this.selectedAttributes[this.swiperColor] = null;
                        }
                        this.$nextTick(() => {
                            $('.single__features li').
                                prepend(
                                    '<svg width="8" height="12"><use xlink:href="#svg_arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>');
                        });
                    }).catch(err => console.log(err)),
                ];

                if (!isVariation) {
                    promiseList.push(
                        this.fetchVariationAttributeMap(targetArticle.id).then(res => {
                            /**
                             * Updated the API because the original function does not work with PHP 8.
                             * The new API delivers a different data structure. Plenty backend development
                             * takes too much time so conversion is done here.
                             */
                            for (let i = 0; i < res.attributes.length; i++) {
                                let values = {};

                                for (let ii = 0; ii < res.attributes[i].values.length; ii++) {
                                    values[res.attributes[i].values[ii].attributeValueId.toString()] = res.attributes[i].values[ii].name;
                                }

                                res.attributes[i].values = values;
                            }

                            targetArticle.attributes = res.attributes;
                            targetArticle.variations = res.variations;

                        }).catch(err => console.log(err)),
                    );
                }

                Promise.all(promiseList).then(() => {
                    this.isLoading = false;
                    if (!isVariation) {
                        this.activeProductData = targetArticle;
                    }
                });
            },

            switchMuster(id) {
                this.modalSelectedMuster = id;
            },

            selectModalColor(id) {
                let usedVar = null;

                if (typeof this.activeAttributes[this.swiperColor] === 'undefined') {
                    usedVar = this.activeAttributes[Object.keys(this.activeAttributes)[0]];
                } else {
                    usedVar = this.activeAttributes[this.swiperColor];
                }

                if (usedVar.values === null || typeof usedVar.values === 'undefined') {
                    let attrWithValues = {};
                    for (let key in this.attributes) {
                        attrWithValues[this.attributes[key].attributeId] = this.attributes[key];
                    }

                    usedVar = attrWithValues[this.swiperColor];
                }

                let selectedColor = '';
                if (typeof usedVar.values[id] !== 'undefined' && typeof usedVar.values[id].name !== 'undefined') {
                    selectedColor = usedVar.values[id].name.split(' - ');
                } else {
                    selectedColor = usedVar.values[id].split(' - ');
                }

                const selectedColorId = selectedColor.splice(0, 1);
                this.modalSelectedColor = {
                    id: id,
                    img: selectedColorId.join(''),
                    name: selectedColor.join(' '),
                };

            },

            fillProductList() {
                let articleData = [];
                let usedIds = [];

                this.confiArticleList.forEach(
                    article => {
                        if (article.data.variationProperties.length > 0) {
                            let namePropVal = '';
                            let imgPropVal = '';

                            // handle different types of variation properties
                            if (typeof article.data.variationProperties[0].position !== 'undefined') {
                                // new var prop structure
                                const nameProp = article.data.variationProperties[0].properties.find(
                                    prop => prop.id === 5);
                                const imgProp = article.data.variationProperties[0].properties.find(
                                    prop => prop.id === 6);
                                if (nameProp) namePropVal = nameProp.values.value;
                                if (imgProp) imgPropVal = imgProp.values.value;

                            } else {
                                // old var prop structure
                                const nameProp = article.data.variationProperties.find(prop => prop.property.id === 5);
                                const imgProp = article.data.variationProperties.find(prop => prop.property.id === 6);
                                if (nameProp) namePropVal = nameProp.values[0].value;
                                if (imgProp) imgPropVal = imgProp.values[0].value;
                            }

                            if (usedIds.indexOf(article.data.item.id) < 0) {
                                articleData.push({
                                    name: namePropVal,
                                    id: article.data.item.id,
                                    varId: article.data.variation.id,
                                    img: imgPropVal,
                                    attributes: article.data.attributes,
                                });

                                usedIds.push(article.data.item.id);
                            }
                        }
                    },
                );
                this.productList = articleData;

                let that = this;
                setTimeout(function() {
                    that.addInitialAttributesAndVariations();
                }, 1);

            },

            addInitialAttributesAndVariations() {
                let formattedAttributes = {};

                this.initialAttributes.forEach(attr => {
                    let attrObject = {};
                    attr.values.forEach(value => {
                        attrObject[value.attributeValueId] = value.name;
                    });

                    formattedAttributes[attr.attributeId] = {...attr, values: attrObject};
                });

                let initialProduct = this.productList.find(prd => prd.id === this.initalActiveProduct);
                this.activeProductData = initialProduct;

                initialProduct.attributes = formattedAttributes;
                initialProduct.variations = this.variations;

                for (let key in this.productList) {
                    if (this.productList.hasOwnProperty(key)) {
                        this.productList[key].attributes = formattedAttributes;
                    }
                }

                if (initialProduct.variations.length === 1000) {
                    this.fetchVariationAttributeMap(this.initalActiveProduct).then(response => {
                        initialProduct.variations = response.variations;
                    });
                }

                this.initializeAttributeList();

                // preselect color for detailsModal
                this.selectModalColor(this.colorArray[0]);
                // preselect product type for modal
                this.modalSelectedMuster = this.initalActiveProduct;
            },

            fetchVariationAttributeMap(id) {
                return new Promise((resolve, reject) => {
                    ApiService.get('/rest/io/variations/map', {itemId: id}).done(response => {
                        resolve(response);
                    }).fail(error => {
                        reject(error);
                    });
                });
            },

            initializeAttributeList() {
                this.initialAttributes.filter(attr => attr.attributeId != this.swiperColor).forEach(attr => {
                    this.$set(this.selectedAttributes, attr.attributeId, parseInt(attr.values[0].attributeValueId));
                });
                this.$set(this.selectedAttributes, this.swiperColor,
                    parseInt(Object.keys(this.activeAttributes[this.swiperColor].values)[0]));
            },

            resetAttributeList() {
                let attrWithValues = {};
                for (let key in this.attributes) {
                    attrWithValues[this.attributes[key].attributeId] = this.attributes[key];
                }

                let newAttributeStructure = {};

                for (let key in this.activeProductData.attributes) {
                    if (typeof this.activeProductData.attributes[key].attributeId !== 'undefined') {
                        newAttributeStructure[this.activeProductData.attributes[key].attributeId] = this.activeProductData.attributes[key];
                    }
                }

                if (Object.keys(newAttributeStructure).length) {
                    this.activeProductData.attributes = newAttributeStructure;
                }

                Object.keys(this.activeProductData.attributes).
                    filter(attr => attr != this.swiperColor).
                    forEach(attr => {
                        if (typeof this.activeProductData.attributes[attr].values !== 'undefined' &&
                            this.activeProductData.attributes[attr].values !== null) {
                            this.selectedAttributes[attr] = Object.keys(
                                this.activeProductData.attributes[attr].values)[0];
                        } else {
                            this.selectedAttributes[attr] = Object.keys(attrWithValues[attr].values)[0];
                        }
                    });

                this.selectedAttributes[this.swiperColor] = null;
            },

        },
};
</script>
